<template>
  <div>
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['dateRange', 'dish']"
           :columns="columns"
          v-model="filter"
          @clear="onClearFilters"
        ></TableFilters>
        <v-row class="py-0 my-0">
          <v-col cols="12" class="py-0 my-0">
            <v-col class="input__label">
              <span> {{ errormessage }}</span></v-col
            >
            <v-row class="py-0 my-0">
              <v-col cols="auto" class="py-1 pr-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      shaped
                      block
                      height="30px"
                      class="report-button"
                      color="blue"
                      @click="
                        generateReport();
                        hide = true;
                      "
                    >
                      <v-icon small>mdi-file-send </v-icon>Generate
                    </v-btn>
                  </template>
                  <span>Genarate</span>
                </v-tooltip>
              </v-col>
               <v-col cols="auto" class="py-1 pr-2" v-if="hide"><v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }"
                    ><v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      class="report-button"
                      color="red"
                      height="30px"
                      block
                      @click="exportPDF()"
                    >
                      <v-icon small>mdi-file-pdf </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to PDF</span>
                </v-tooltip></v-col
              >
              <v-col cols="auto" class="py-1 pr-2" v-if="hide">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="30px"
                      v-bind="attrs"
                      v-on="on"
                      block
                      class="report-button"
                      color="green"
                      @click="exceldownload()"
                    >
                      <v-icon small>mdi-file-excel </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to Excel</span>
                </v-tooltip></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                 :v-model:options="pagination"
                :items-per-page="pagination.itemsPerPage"
                :items-per-page-options="[5, 10, 20, 50, 100, 1000, -1]"
                :fixed-header="true"
                :headers="headers"
                :items="foodorders"
                item-key="id"
                class="row-pointer product-list"
                id="indextable"
              >
                <template
                  slot="body.append"
                  v-if="foodorders && foodorders.length > 0"
                >
                  <tr class="black--text">
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th>
                      <h3 class="pl-0">
                        {{ total | formatCurrency }}
                      </h3>
                    </th>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import TableFilters from "@/components/base/TableFilters";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx";
import { DateTime } from "@grapecity/wijmo";
import moment from "moment";
import _ from "lodash";
export default {
  data: () => ({
    errormessage: "",
    columns: [
      {
        text: "Number",
        value: "no",
        show: true,
        disabled: false,
      },
      {
        text: "Code",
        value: "dish.code",
        show: true,
        disabled: false,
      },
      {
        text: "Name",
        value: "dish.name",
        show: true,
        disabled: false,
      },
      {
        text: "Quantity",
        value: "quantity",
        show: true,
        disabled: false,
      },

      {
        text: "Amount",
        value: "amount",
        show: true,
        disabled: false,
      },
    ],
    pagination: {
    page: 1,
    itemsPerPage: -1,
  },

    foodorders: [],
    date_range: [],
    // Filters
    total: 0,
    paidamount: 0,
    servicecharge: 0,
    descount: 0,
    filter: {
      foodorderproduct: "",
      start: "",
      end: "",
    },
  }),
  components: {
    PageTitle,
    TableFilters,
  },
  mounted() {
    this.generateReport();
  },

  methods: {
    dateFormat: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    generateReport() {
      var filter = this.filter;
      this.$store
        .dispatch("report/getFoodReports", filter)
        .then((res) => {
          let i = 1;
          this.foodorders = res.data.data;
          this.foodorders.map((p) => {
            p.no = i;
            i++;
          });
          this.total = this.sumField(this.foodorders, "amount");
          this.errormessage = "";
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    exportPDF() {
  const Data = _.cloneDeep(this.foodorders);

  const today = new Date(); // FIX 1: Move today to top

  // Prepare table rows
  const rows = Data.map(item => [
    item.no,
    item.dish.code,
    item.dish.name,
    item.quantity,
    item.amount
  ]);

  // Prepare table headers
  const head = [
    ["Number", "Code", "Name", "Quantity", "Amount"]
  ];

  const doc = new jsPDF({ orientation: "landscape" });

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Food Orders Report", 14, 10);

  doc.setFontSize(11);
  doc.text(
    `Generated: ${moment(today).format("DD-MM-YYYY HH:mm:ss")}`,
    14,
    16
  );
  
      doc.text(180, 10, `Total Amount :- ${this.total}.00`);

  // FIX 2: New AutoTable format
  autoTable(doc, {
    head: head,
    body: rows,
    startY: 20
  });

  doc.save(`${moment(today).format("DD-MM-YYYY")}-foodorders.pdf`);
}
,

    //Food Details Export Excel
    exceldownload() {
      var data = document.getElementById("indextable");
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format("DD-MM-YYYY")
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format("DD-MM-YYYY")}-FoodOrders.xlsx`
      );
    },
    onClearFilters() {
      this.PurchaseList = [];
      this.hide = false;

      this.$nextTick(() => {
        this.generateReport();
      });
    },
  },
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(" ~ ");
    },
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
<style scoped>
.input__label {
  color: rgb(236, 25, 25);
}
</style>
